import styled from "styled-components";

const Container = styled.div`
  padding: 40px 119px 80px 119px;
  margin: 0;
  background: ${(props) => (!props.background ? "" : props.background)};
  border-radius: 0px 96px;
  @media (max-width: 576px) {
    padding: 0 16px 39px 16px;
  }
`;

export default Container;
